module.exports = __webpack_public_path__ + "img/cs.c0a42e05.svg";